// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const EnumEnvironmentOperationType = {
  EnvOpTypeCreate: 'CREATE',
  EnvOpTypeUpdate: 'UPDATE',
  EnvOpTypeDelete: 'DELETE',
  EnvOpTypeScaleUp: 'SCALE_UP',
  EnvOpTypeScaleDown: 'SCALE_DOWN',
} as const;
export type EnumEnvironmentOperationType =
  (typeof EnumEnvironmentOperationType)[keyof typeof EnumEnvironmentOperationType];

export function instanceOfEnumEnvironmentOperationType(value: any): boolean {
  for (const key in EnumEnvironmentOperationType) {
    if (
      Object.prototype.hasOwnProperty.call(EnumEnvironmentOperationType, key)
    ) {
      if (
        EnumEnvironmentOperationType[
          key as keyof typeof EnumEnvironmentOperationType
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function EnumEnvironmentOperationTypeFromJSON(
  json: any,
): EnumEnvironmentOperationType {
  return EnumEnvironmentOperationTypeFromJSONTyped(json, false);
}

export function EnumEnvironmentOperationTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnumEnvironmentOperationType {
  return json as EnumEnvironmentOperationType;
}

export function EnumEnvironmentOperationTypeToJSON(
  value?: EnumEnvironmentOperationType | null,
): any {
  return value as any;
}

export function EnumEnvironmentOperationTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): EnumEnvironmentOperationType {
  return value as EnumEnvironmentOperationType;
}
